import { render, staticRenderFns } from "./PortalForm.vue?vue&type=template&id=391acf6a&"
import script from "./PortalForm.vue?vue&type=script&lang=js&"
export * from "./PortalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports